export default {
	duplicateMode: {
		body: `Mode copie de rendez-vous`,
	}
}
